import React from "react";
import styles from "./HotelCard.module.css";

interface HotelCardProps {
  hotelName: string;
  address: string;
  phone: string;
  bookingUrl: string;
  eventDates: string;
  bookByDate: string;
  rooms: Array<{
    type: string;
    price: string;
  }>;
  logo?: string;
  image?: string;
}

const HotelCard: React.FC<HotelCardProps> = ({
  hotelName,
  address,
  phone,
  bookingUrl,
  eventDates,
  bookByDate,
  rooms,
  logo,
  image
}) => (
  <div className="card">
    {image && (
      <div className={styles.hotelImageContainer}>
        <img src={image} alt={`${hotelName} exterior`} className={styles.hotelImage} />
      </div>
    )}
    
    <div className="cardContent">
      <div className="cardHeader">
        <div>
          <h3 className="cardTitle">{hotelName}</h3>
          <div className="cardSubtitle">{address}</div>
          <div className={styles.hotelPhone}>{phone}</div>
        </div>
      </div>

      <div className={styles.bookingInfo}>
        <div className={styles.eventDates}>
          <strong>Event dates:</strong> {eventDates}
        </div>
        <div className={styles.bookByDate}>
          <strong>Book by:</strong> {bookByDate}
        </div>
      </div>

      <div className={styles.roomsSection}>
        <h4 className={styles.roomsTitle}>Rooms & Rates</h4>
        <div className={styles.roomsNote}>
          Price includes 0.53% mandatory charge per stay, but excludes tax
        </div>
        
        <div className={styles.roomsList}>
          {rooms.map((room, index) => (
            <div key={index} className={styles.roomItem}>
              <span className={styles.roomType}>{room.type}</span>
              <span className={styles.roomPrice}>{room.price}</span>
            </div>
          ))}
        </div>
      </div>

      <a 
        href={bookingUrl} 
        target="_blank" 
        rel="noopener noreferrer" 
        className="primary-btn"
      >
        Book Your Room
      </a>
    </div>
  </div>
);

export default HotelCard;
